import { cn } from "@/lib/utils";

interface StatsGridProps {
  children: React.ReactNode;
  columns?: 2 | 3 | 4 | 5;
  className?: string;
}

const columnClass: Record<number, string> = {
  2: "grid-cols-2",
  3: "grid-cols-2 sm:grid-cols-3",
  4: "grid-cols-2 lg:grid-cols-4",
  5: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5",
};

const StatsGrid = ({ children, columns = 4, className }: StatsGridProps) => {
  return (
    <div className={cn("grid gap-3 lg:gap-5", columnClass[columns], className)}>
      {children}
    </div>
  );
};

export default StatsGrid;
